import { useEffect } from 'react';

const loadJivoScript = () => {
    const script = document.createElement('script');
    script.src = "//code.jivosite.com/widget/nps1TpwlI5";
    script.async = true;
    document.body.appendChild(script);
};

const JivoChatLoader: React.FC = () => {
    useEffect(() => {
        loadJivoScript();
    }, []);

    return null; // Компонент не рендерит ничего
};

export default JivoChatLoader;




// import { useEffect } from 'react';
//
// const useJivoChat = (isChatVisible: boolean) => {
//     useEffect(() => {
//         // Constants for JivoChat settings
//         const jivoId = 'nps1TpwlI5';
//         const jivoChatScriptSrc = 'https://code.jivosite.com/widget.js';
//
//         // Function to toggle visibility of JivoChat elements
//         const toggleJivoElementsVisibility = () => {
//             document.querySelectorAll('.globalClass_ebf4').forEach(element => {
//                 element.classList.toggle('jvlabelNone', !isChatVisible);
//                 element.classList.toggle('jvlabelBlock', isChatVisible);
//             });
//         };
//
//         // Function to remove JivoChat elements
//         const removeJivoElements = () => {
//             document.querySelectorAll('[data-jv-id]').forEach(element => {
//                 element.parentNode?.removeChild(element);
//             });
//         };
//
//         // Function to remove JivoChat script
//         const removeJivoScript = () => {
//             const jivoChatScript: HTMLScriptElement | null = document.querySelector(`[data-jv-id="${jivoId}"]`);
//             if (jivoChatScript && jivoChatScript.parentNode) {
//                 jivoChatScript.parentNode.removeChild(jivoChatScript);
//             }
//         };
//
//         // Function to handle JivoChat script load
//         const handleJivoScriptLoad = () => {
//             if (!isChatVisible) {
//                 removeJivoElements();
//                 removeJivoScript();
//             }
//         };
//
//         // Effect for adding or removing JivoChat script
//         if (isChatVisible) {
//             removeJivoElements();
//
//             const jivoChatScript = document.createElement('script');
//             jivoChatScript.src = jivoChatScriptSrc;
//             jivoChatScript.setAttribute('data-jv-id', jivoId);
//             jivoChatScript.onload = handleJivoScriptLoad;
//             document.body.appendChild(jivoChatScript);
//         } else {
//             removeJivoElements();
//             removeJivoScript();
//         }
//
//         // Toggle visibility of JivoChat elements
//         toggleJivoElementsVisibility();
//
//         // Cleanup function
//         return () => {
//             removeJivoElements();
//             removeJivoScript();
//         };
//     }, [isChatVisible]);
// };
//
// export default useJivoChat;
